import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { useSession } from "@descope/react-sdk";
import { createRouter, RouterProvider } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen.ts";
import './index.css'
import { GlobalErrorBoundary, PlatformAuthProvider, SessionQueryClientProvider } from "@nxt-platform/global-components";
import { ToastProvider } from '@nxt-shared/ui/components/Toast';
import { client } from './api/client.gen.ts';

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Keep the generated tenant-backend client authenticated with the live Descope session token.
// baseUrl "" → same-origin (apps.<domain>/management/api in prod; the Vite proxy in dev).
function ApiClientProvider({ children }: { children: React.ReactNode }) {
  const { sessionToken } = useSession()

  // While rendering, not in an effect: the subtree remounted for a new user starts its queries in
  // child effects, which run before a parent's, so they would still carry the previous user's token.
  client.setConfig({
    auth: sessionToken,
    baseUrl: "",
  })

  return <>{children}</>
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <GlobalErrorBoundary>
        <PlatformAuthProvider restoreSharedSession>
          <ApiClientProvider>
            <SessionQueryClientProvider>
              <ToastProvider>
                <RouterProvider router={router} />
              </ToastProvider>
            </SessionQueryClientProvider>
          </ApiClientProvider>
        </PlatformAuthProvider>
      </GlobalErrorBoundary>
    </StrictMode>,
  )
}
